import {useDictionary} from '@adamlip/okeoke.client';
import {RadioGroup} from '@heroui/react';
import CustomRadio from 'components/_NewComponents/Radio';
import useStorage from 'hooks/useStorage';
import moment from 'moment';
import {useEffect, useState} from 'react';

export default function SimplePayParams({cards}) {
	const {getSV, setSV, removeSV} = useStorage();
	const {getValue} = useDictionary();

	const [simplePayCard, setSimplePayCard] = useState(getSV('simplePayCardID'));

	const handleSelectCard = (id) => {
		setSimplePayCard(id);
		if (id != null) {
			setSV('simplePayCardID', id);
		} else {
			removeSV('simplePayCardID');
		}
	};

	useEffect(() => {
		if (cards && cards?.length > 0) {
			setSimplePayCard(cards[0]?.id || -1);
			setSV('simplePayCardID', cards[0]?.id || -1);
		}
		// eslint-disable-next-line
	}, [cards]);

	return (
		<div className='pb-4'>
			<RadioGroup label={getValue('app_v2_saved_cards_radio_title')} value={simplePayCard} onValueChange={handleSelectCard}>
				{cards != null &&
					cards?.length > 0 &&
					cards.map((card) => (
						<CustomRadio key={card.id} value={card.id} description={getValue('app_v2_saved_cards_expiry') + ': ' + moment(card.expiry).format('YY/MM/DD')}>
							{card.cardMask}
						</CustomRadio>
					))}
				<CustomRadio value='-1'>{getValue('app_v2_saved_cards_dont_save')}</CustomRadio>
				<CustomRadio value='0'>{getValue('app_v2_saved_cards_save')}</CustomRadio>
			</RadioGroup>
		</div>
	);
}
